// extracted by mini-css-extract-plugin
export default {"button":"FilterMenuButton-module__button___h1Q37","icon":"FilterMenuButton-module__icon___ydz6R","label":"FilterMenuButton-module__label___SKZ25"};